import type { DataLayerInfo, PageInfo } from '../../../../shared/types'

export const getPolicyAndInsightLandingSubVerticalDataLayer = (pageInfo: PageInfo) => {
  const policyAndInsightLandingDataLayer: DataLayerInfo = {
    ...pageInfo,
    topicName: pageInfo.sub_vertical,
    content_type: 'policy-and-insight',
  }

  delete policyAndInsightLandingDataLayer.sub_vertical

  return policyAndInsightLandingDataLayer
}
